import { TIERS } from "../../constants/membership";

export function shouldShowPremiumMatchFiltersPrompt({
    membershipTier,
    currentLobbyCode = null,
    canEditLobbySettings = false,
} = {}) {
    if (membershipTier !== TIERS.FREE) return false;
    if (currentLobbyCode && !canEditLobbySettings) return false;
    return true;
}
